/**
 * Simulation URL parameters, read ONCE when the app boots. They make every
 * simulated screen reachable from a plain link, for the client demo and for
 * the screenshot/video scripts:
 *
 *   shots=1      screenshot mode: hides the demo banner and the Sim Panel, pins
 *                the date to 2026-10-20 (09:30), drops mock latency, and keeps
 *                first-run overlays closed unless a feature's own parameter
 *                asks for one (e.g. welcome=1, guidelines=1)
 *   reset=1      start from a fresh simulation store
 *   market=…     main | ph (the season card and PH content need ph)
 *   scenario=…   normal | typhoon | heavyRain | dengue | backToSchool | heat;
 *                or `empty`: a brand-new account with no children, links or
 *                alerts (lib/api/demoMode.ts; the season stays normal)
 *   region=…     "Tacloban City" or its short id ("tacloban")
 *   simDate=…    YYYY-MM-DD
 *   persona=…    firstWeek | regular
 *   state=a,b    run named presets that features register (e.g. wins.allDone)
 *
 * Features read their own extra parameters with getSimParam().
 */
const search = typeof window === "undefined" ? "" : window.location.search;

export const SIM_PARAMS: URLSearchParams = new URLSearchParams(search);

export const IS_SHOTS = SIM_PARAMS.get("shots") === "1";

/** The date every screenshot is pinned to. */
export const SHOTS_DATE = "2026-10-20";

export function getSimParam(name: string): string | null {
  return SIM_PARAMS.get(name);
}
